import React from "react";

export type Option = {
  value: string | number;
  label: string;
  disabled?: boolean;
};

interface SelectProps {
  name?: string;
  value: string | number;
  onChange: (value: string) => void;
  options?: Option[]; // optional
  placeholder?: string;
  required?: boolean;
  className?: string;
  children?: React.ReactNode; // optional
}

const Select: React.FC<SelectProps> = ({
  name,
  value,
  onChange,
  options = [], // ✅ default empty array
  placeholder = "Select...",
  required = false,
  className = "",
  children,
}) => {
  return (
    <select
      name={name}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      className={`w-full px-3 py-2 rounded-md border text-sm
        bg-white text-slate-900 border-slate-300
        dark:bg-slate-900 dark:text-slate-100 dark:border-slate-700
        focus:outline-none focus:ring-2 focus:ring-blue-500
        ${className}`}
    >
      {placeholder && <option value="">{placeholder}</option>}

      {options.map((opt) => (
        <option key={opt.value} value={opt.value} disabled={opt.disabled}>
          {opt.label}
        </option>
      ))}

      {children} {/* optional children support */}
    </select>
  );
};

export default Select;
